/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Firstname_Placeholder1Inputs */

const en_user_profile_firstname_placeholder1 = /** @type {(inputs: User_Profile_Firstname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter user first name`)
};

const de_user_profile_firstname_placeholder1 = /** @type {(inputs: User_Profile_Firstname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vornamen des Benutzers eingeben`)
};

/**
* | output |
* | --- |
* | "Enter user first name" |
*
* @param {User_Profile_Firstname_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const user_profile_firstname_placeholder1 = /** @type {((inputs?: User_Profile_Firstname_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Firstname_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_user_profile_firstname_placeholder1(inputs)
	return en_user_profile_firstname_placeholder1(inputs)
});
export { user_profile_firstname_placeholder1 as "user_profile_firstName_placeholder" }